import React, { PropsWithChildren } from "react"

import { CustomerInfoProvider, useCustomerInfo } from "@cirrus/common/CustomerInfo"
import { CustomerInfoServiceHttp } from "@cirrus/common/CustomerInfo/service/Http"
import { useFrontendConfig } from "@cirrus/common/FrontendConfig"


export const WithCustomerInfo = ({ children }: PropsWithChildren) => {
  const config = useFrontendConfig()

  return (<CustomerInfoProvider service={new CustomerInfoServiceHttp(config.Customer)}>
    <ErrorHandler/>

    {children}
  </CustomerInfoProvider>)
}

const ErrorHandler = ({ children }: PropsWithChildren) => {
  const { error } = useCustomerInfo()

  if (error) {
    // @ts-ignore | TODO: Set error type
    error.response?.data?.status === 404 ? window.location.assign("/site-entry") : window.location.assign("/500")
  }

  return null
}
